import React from "react";

import { Wrapper } from "../../Wrapper";
import { ViewMoreListItem } from "./ViewMoreListItem";
import styles from "../styles/ViewMore.module.scss";

export const ViewMore = ({ data, children }: any) => (
  <section className={styles.viewMoreWrapper}>
    <Wrapper isLarge>
      <h2 className={styles.title}>{data.title}</h2>
      <ul className={styles.list}>{children}</ul>
    </Wrapper>
  </section>
);

ViewMore.ListItem = ViewMoreListItem;
